"use client";
import { VisualizeSpecialData } from "@/types/common";
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";

import { formatYAxisTick } from "./chartAxis";

const CHART_MARGIN = { top: 10, right: 14, left: 10, bottom: 8 } as const;

export const AreaChartComponent: React.FC<VisualizeSpecialData> = ({ data, title, yAxisLabel }) => {
  return (
    <div className="p-4 bg-white shadow-lg rounded-lg overflow-hidden">
      <h2 className="text-lg font-semibold mb-4 max-w-full break-words leading-snug pr-1">{title}</h2>
      <ResponsiveContainer width="100%" height={300} className="min-h-[300px]">
        <AreaChart data={data} margin={CHART_MARGIN}>
          <defs>
            <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
              <stop offset="25%" stopColor="#8884d8" stopOpacity={0.7} />
              <stop offset="55%" stopColor="#82ca9d" stopOpacity={0.5} />
              <stop offset="85%" stopColor="#82ca9d" stopOpacity={0.2} />
              <stop offset="95%" stopColor="#8884d8" stopOpacity={0.1} />
            </linearGradient>
          </defs>
          <XAxis dataKey="name" tickMargin={8} />
          <YAxis
            width={100}
            tickMargin={10}
            tickFormatter={formatYAxisTick}
            tick={{ fontSize: 12 }}
            domain={["auto", "auto"]}
          />
          <Tooltip formatter={value => [value, yAxisLabel || "Value"]} />
          <Area
            type="monotoneX"
            dataKey="point"
            stroke="#FF0000"
            fill="url(#colorUv)"
            dot={{ r: 4 }}
            activeDot={{ r: 6 }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default AreaChartComponent;